import VueRouter from 'vue-router';
import routes from './routes';
import store from '@/store';
import {TokenService} from '@/services/storage.service.js';

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active',
  scrollBehavior() {
    const container = document.querySelector('.main-panel');
    if (container) {
      container.scrollTop = 0;
    }
    return {x: 0, y: 0};
  }
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();

  const toMeta = to.meta;

  if (!isPublic && !loggedIn) {
    return next({
      path: '/auth/login'
    });
  }

  let rolesRequired = false;
  to.matched.some(record => {
    if (!rolesRequired && record.meta.permission) {
      rolesRequired = record.meta.permission;
    }
  })

  let specificRouteRolesRequired = false;
  if (to.meta.permission !== undefined) {
    specificRouteRolesRequired = to.meta.permission;
  }

  // Do not allow user to visit login page or register page if they are logged in
  if ((!toMeta || toMeta.onlyWhenLoggedOut !== false) && loggedIn && onlyWhenLoggedOut) {
    return next('/dashboard')
  }

  if (loggedIn) {
    let initializations = [];
    initializations.push(store.dispatch('Auth/initCheck'));

    Promise.all(initializations).then(function () {
      let loggedUser = store.getters['Auth/loggedUser'];

      // check password change required
      let newPasswordPath = '/user/new-password';
      let logoutPath = '/user/logout';
      if (loggedUser.requireNewPassword && [newPasswordPath, logoutPath].indexOf(to.path) === -1) {
        return next(newPasswordPath);
      }
      if ((rolesRequired && rolesRequired.indexOf(loggedUser.role) === -1) || (specificRouteRolesRequired && specificRouteRolesRequired.indexOf(loggedUser.role) === -1)) {
        return next('/permission-error');
      } else {
        next();
      }

    });

  } else {
    next();
  }
})

export default router;
